<template>

  <inertia-link v-bind="$props" :method="$props.method ?? 'get'" class="Link">
    <span v-if="rawhtml" class="Link__text" v-html="rawhtml"></span>
    <span v-else class="Link__text">
      <slot />
    </span>
  </inertia-link>
</template>

<script>
export default {
  props: ['rawhtml']
}
</script>

<style lang="scss">
@import "~@sass/components/_Link.scss";
</style>
